import React from 'react';
import Description from '../Description/Description';
import './InfoViewText.css';

interface InfoViewTextProps {
  icon?: React.ReactNode;
  title: string;
  lines?: string[];
  bold?: boolean;
}

function InfoViewText({ icon, title, lines, bold }: InfoViewTextProps): React.ReactNode {
  return (
    <div className="info-view-text">
      {icon}
      <h1>{title}</h1>
      {lines && <Description lines={lines} bold={bold} />}
    </div>
  );
}

export default InfoViewText;
